var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "grid fuel-utilization__work-order",
        attrs: { classes: _vm.innerClasses },
        on: {
          click: function($event) {
            return _vm.handleClick($event, _vm.workOrder.work_order__id)
          },
          mouseleave: _vm.hideComment
        }
      },
      [
        _c("div", { staticClass: "grid fuel-utilization-wo__details" }, [
          _c("div", { staticClass: "grid__col--9" }, [
            _c("div", { staticClass: "fuel-utilization-wo__title" }, [
              _vm._v(
                "\n          FM" +
                  _vm._s(_vm.workOrder.work_order_id) +
                  " - " +
                  _vm._s(_vm.workOrder.title) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fuel-utilization-wo__dates" }, [
              _c("span", { staticClass: "h-italic-text" }, [
                _vm._v("Created - " + _vm._s(_vm.workOrder.created))
              ]),
              _vm._v(" "),
              _vm.workOrder.completed
                ? _c("span", [
                    _vm._v(" |\n            "),
                    _c("span", {
                      staticClass:
                        "fuel-utilization-wo__glyph--completed glyphicon glyphicon-ok-sign",
                      attrs: { "aria-hidden": "true" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.workOrder.completed
                ? _c("span", { staticClass: "h-italic-text" }, [
                    _vm._v(_vm._s(_vm.workOrder.completed))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "fuel-utilization-wo__description is-displayed-mobile",
              domProps: { innerHTML: _vm._s(_vm.workOrder.details) }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "grid__col--1 h-center-align h-no-left-pad h-no-margin is-hidden-mobile"
            },
            [
              _c("div", { staticClass: "fuel-utilization-wo__hours" }, [
                _vm._v(_vm._s(_vm.workOrder.timeSpent))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid" }, [
          _c("div", {
            staticClass: "fuel-utilization-wo__description is-hidden-mobile",
            domProps: { innerHTML: _vm._s(_vm.workOrder.details) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "fuel-utilization-wo__hours-worked-container is-displayed-mobile"
          },
          [
            _c(
              "div",
              { staticClass: "fuel-utilization-wo__hours-worked-module" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "fuel-utilization-wo__hours-worked-module-content fuel-utilization-wo__hours-worked h-right-align"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "fuel-utilization-wo__hours fuel-utilization-wo__hours--label h-display-inline-block"
                      },
                      [_vm._v("Hours worked: ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "fuel-utilization-wo__hours fuel-utilization-wo__hours--value h-display-inline-block"
                      },
                      [_vm._v(_vm._s(_vm.workOrder.timeSpent))]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fuel-utilization-wo__hours-worked-module" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "fuel-utilization-wo__hours-worked-module-content fuel-utilization-wo__status"
                  },
                  [_vm._v(_vm._s(_vm.workOrder.portalStatus))]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid" }, [
          _c("div", { staticClass: "fuel-utilization-wo__dimension-tags" }, [
            _vm.workOrder.department
              ? _c(
                  "div",
                  {
                    class: [
                      "fuel-utilization-wo__dimension",
                      "fuel-utilization-wo__dimension--department",
                      "fuel-utilization-wo__dimension--department--" +
                        _vm.slug(_vm.workOrder.department)
                    ]
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.workOrder.department) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.workOrder.specialty
              ? _c(
                  "div",
                  {
                    class: [
                      "fuel-utilization-wo__dimension",
                      "fuel-utilization-wo__dimension--specialty",
                      "fuel-utilization-wo__dimension--specialty--" +
                        _vm.workOrder.specialty
                    ]
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.workOrder.specialty) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.workOrder.objective
              ? _c(
                  "div",
                  {
                    class: [
                      "fuel-utilization-wo__dimension",
                      "fuel-utilization-wo__dimension--objective",
                      "fuel-utilization-wo__dimension--objective--" +
                        _vm.workOrder.objective
                    ]
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.workOrder.objective) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.workOrder.status
              ? _c(
                  "div",
                  {
                    class: [
                      "fuel-utilization-wo__dimension",
                      "fuel-utilization-wo__dimension--status",
                      "is-hidden-mobile"
                    ]
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.ucfirst(_vm.workOrder.status)) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.divider
      ? _c("div", { staticClass: "wo-divider--dots" }, [
          _c("span", {
            staticClass: "glyphicon glyphicon-option-horizontal",
            attrs: { "aria-hidden": "true" }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "grid__col--2 h-right-align h-no-right-pad is-hidden-mobile"
      },
      [
        _c("div", { staticClass: "fuel-utilization-wo__hours-worked" }, [
          _vm._v("Hours worked:")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }